import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal, Typography, IconButton, Icon, Divider, FormControlLabel, Switch } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import dayjs from 'dayjs';

import themeColors from '../../assets/colors';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    header: {
        position: "sticky",
        top: 0,
        marginBottom: 10
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.background.default,
        padding: 20,
        width: '80%',
        maxHeight: '90%',
        borderRadius: 10,
    },
    content: {
        marginTop: 10,
        overflow: "auto"
    },
    close: {
        position: "absolute",
        display: 'flex',
        alignSelf: 'flex-end',
        padding: 0,
        marginRight: -5,
        zIndex: 100
    },
    table: {
        border: 1,
        borderColor: "rgba (0, 0, 0, 0.2)",
        marginBottom: 10,
        paddingBottom: 0
    },
    switch: {
        marginRight: 8,
        marginLeft: 10,
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#aab4be',
        }
    }

}));

const ScannerMobileHistory = ({ open, onClose, employee, data = [] }) => {

    const [showErrorReport, setShowErrorReport] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [showWarningSwitch, setShowWarningSwitch] = useState(false);

    const classes = useStyles();
    var dateTitle = "";

    useEffect(() => {
        let filtered = data.filter(i => i.idpaylocity_scanner_out === "-")
        setShowWarningSwitch(filtered.length !== 0);
        if (showErrorReport) {
            setFilteredData(filtered)
        } else {
            setFilteredData(data)
        }
    }, [open, showErrorReport])

    const handleSwitchChange = (event) => { setShowErrorReport(event.target.checked) };

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.root}
        >
            <div className={classes.container}>

                <IconButton
                    className={classes.close}
                    onClick={onClose}
                >
                    <Icon fontSize='large'>{"cancel"}</Icon>
                </IconButton>

                <div className={classes.header}>
                    <Typography variant='h1'>{'History'}</Typography>
                    <Typography variant='h2'>{`${employee.code} - ${employee.name}`}</Typography>
                    {showWarningSwitch && <FormControlLabel
                        style={{ marginBottom: 10 }}
                        control={<Switch checked={showErrorReport} onChange={handleSwitchChange} className={classes.switch} />
                        }
                        label={`Show only open blocks`}
                    />}
                    <Divider />
                </div>

                <div className={classes.content}>

                    {filteredData?.map(i => {
                        let showDate = dateTitle !== i.start_date;
                        dateTitle = i.start_date;
                        return (
                            <>
                                {showDate && <h3>{dayjs(i.start_date).format("MM/DD/YYYY")}</h3>}
                                <TableContainer key={i.idpaylocity_scanner_in} className={classes.table} component={Paper}>
                                    <Table size="small" style={{ tableLayout: "auto", marginBottom: 0 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" colSpan={2}>
                                                    {`${i.action} hours: ${i.hours}`}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align="center" >{"In"}</TableCell>
                                                <TableCell align="center" >{"Out"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center">{`${dayjs(i.start_date).format('MMMM DD, YYYY')}`}</TableCell>
                                                <TableCell align="center">{`${dayjs(i.stop_date).format('MMMM DD, YYYY')}`}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center">{i.start_time}</TableCell>
                                                <TableCell align="center">{i.stop_time}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center" colSpan={2}>{`${i.cc1} | ${i.cc2} | ${i.cc3}`}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        )
                    })
                    }

                </div>

            </div>
        </Modal>
    );
}

export default ScannerMobileHistory;